// src/config.js
const config = {
     //BASE_URL: "http://localhost:5000",  // Use the actual base URL of your API
    //  BASE_URL: "http://92.205.180.36:5000",  // Use the actual base URL of your API
    BASE_URL: "https://api.littlecoveespresso.com",  // Use the actual base URL of your API
};
  
export default config;
  